import { useEffect, useState } from "react";
import countryList from "react-select-country-list";

const useCountryOptions = (allCountries = false) => {
  const [countryOptions, setCountryOptions] = useState([]);
  const alwaysExcluded = ["Åland Islands"];
  const conditionallyExcluded = allCountries ? [] : ["Nigeria"];

  useEffect(() => {
    const fetchCountryOptions = async () => {
      try {
        const countries = await countryList().getData();
        
        const filteredCountries = countries.filter(
          (country) => 
            !alwaysExcluded.includes(country.label) && 
            !conditionallyExcluded.includes(country.label)
        );
        const options = filteredCountries.map((country) => ({
          value: country.value,
          label: country.label,
        }));
        setCountryOptions(options);
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    fetchCountryOptions();
  }, []);

  return countryOptions;
};

export default useCountryOptions;
